import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const MarqueeItemSettingsV1 = z.object({
  src: z.string(),
  altText: z.string(),
})

export type TMarqueeItemSettingsV1 = z.infer<typeof MarqueeItemSettingsV1>

export const MarqueeItemElementV1 = z.object({
  id: z.string(),
  name: z.literal("marqueeItem"),
  settings: MarqueeItemSettingsV1,
})

export type TMarqueeItemElementV1 = z.infer<typeof MarqueeItemElementV1>

export const MarqueeSettingsV1 = z.object({
  reverse: z.union([z.literal(true), z.literal(false)]),
})

export type TMarqueeSettingsV1 = z.infer<typeof MarqueeSettingsV1>

export const MarqueeElementV1 = z.object({
  id: z.string(),
  name: z.literal("marquee"),
  settings: MarqueeSettingsV1,
  container: ContainerOptionsV1,
  children: z.array(MarqueeItemElementV1),
})

export type TMarqueeElementV1 = z.infer<typeof MarqueeElementV1>

// Latest ---------------------
export const MarqueeItemSettings = MarqueeItemSettingsV1
export type TMarqueeItemSettings = TMarqueeItemSettingsV1
export const MarqueeItemElement = MarqueeItemElementV1
export type TMarqueeItemElement = TMarqueeItemElementV1
export const MarqueeSettings = MarqueeSettingsV1
export type TMarqueeSettings = TMarqueeSettingsV1
export const MarqueeElement = MarqueeElementV1
export type TMarqueeElement = TMarqueeElementV1
